import React from 'react';

type Doctor = {
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  price: number;
  originalPrice?: number;
  photoUrl: string;
  is_online?: boolean; // Optional property to indicate if the doctor is online
};

interface DoctorCardProps {
  doctor: Doctor;
  onConsult?: () => void;
}


const DoctorCard: React.FC<DoctorCardProps> = ({ doctor, onConsult }) => {
  return (
    <div className="flex items-center bg-white p-4 rounded-xl shadow mb-4">
      {/* Foto */}
      <div className="relative mr-4 shrink-0">
        <img
          src={doctor.photoUrl}
          alt={doctor.name}
          onError={(e) => {
            e.currentTarget.src =
              'https://m.linksehat.com/assets/img/users/dummy.jpg';
          }}
          className="w-16 h-16 rounded-lg object-cover"
        />
        <span
          className={`w-3 h-3 rounded-full absolute bottom-0 right-0 border-2 border-white ${
            doctor.is_online ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
      </div>

      {/* Info Dokter */}
      <div className="flex-1 min-w-0">
        {/* Nama */}
        <h4 className="font-semibold truncate">
          {doctor.name}
        </h4>

        {/* Spesialis */}
        <p className="text-sm text-gray-500 truncate">
          {doctor.specialization}
        </p>

        {/* Experience */}
        <div className="flex items-center gap-4 mt-1 text-sm text-gray-600">
          <div className="flex items-center gap-1 whitespace-nowrap">
            <img src="/icons/briefcase.svg" alt="Years" className="w-4 h-4" />
            <span>{doctor.years} yrs</span>
          </div>

          <div className="flex items-center gap-1 whitespace-nowrap">
            <img src="/icons/thumb-up.svg" alt="Rating" className="w-4 h-4" />
            <span>{doctor.rating}%</span>
          </div>
        </div>
      </div>

      {/* Tombol */}
      <div className="ml-4 shrink-0">
        <button
          className={`text-white px-4 py-1 rounded-full text-sm whitespace-nowrap
                      ${doctor.is_online ? 'bg-morning-300' : 'bg-gray-400'}`}
          onClick={onConsult}
          disabled={!doctor.is_online}
        >
          {/* {doctor.is_online ? 'Konsultasi' : 'Jadwalkan'} */}
          Konsultasi
        </button>
      </div>
    </div>
  );
};

export default DoctorCard;
